/**
 * Regenerated replies (CINCHAI-124). A regenerated reply and the one it replaced are siblings: both
 * have `parent` = the user message. The thread shows each question followed by ONE of its replies
 * (the question's `active_child`, else the newest), with `siblings: { index, count, ids, question }`
 * for the "‹ 1/2 ›" switcher. What is shown is also what later turns continue from.
 */
export function visibleMessages(messages) {
  const childrenOf = new Map();
  messages.forEach(m => {
    if (m.role === 'assistant' && m.parent) childrenOf.set(m.parent, [...(childrenOf.get(m.parent) || []), m]);
  });
  const shown = [];
  messages.forEach(m => {
    if (m.role === 'assistant' && m.parent && childrenOf.has(m.parent) && messages.some(q => q.id === m.parent)) return;
    shown.push(m);
    const kids = m.role === 'user' && m.id ? childrenOf.get(m.id) : null;
    if (!kids) return;
    // Saved replies in seq order; a reply still streaming (no seq yet) is the newest.
    const ordered = [...kids].sort((a, b) => (a.seq ?? Infinity) - (b.seq ?? Infinity));
    const active = ordered.find(k => k.id && k.id === m.active_child) || ordered[ordered.length - 1];
    shown.push({
      ...active,
      siblings: {
        index: ordered.indexOf(active),
        count: ordered.length,
        ids: ordered.map(k => k.id || k.localId),
        question: m
      }
    });
  });
  return shown;
}

/** The question a reply answers (the nearest user message before it in what is shown). */
export function questionFor(shown, reply) {
  const at = shown.findIndex(m => reply.id ? m.id === reply.id : m.localId === reply.localId);
  return at < 0 ? null : [...shown.slice(0, at)].reverse().find(m => m.role === 'user') || null;
}